export function assertPresence<T>(value: T): asserts value is Exclude<T, undefined | null> {
	if (value === undefined || value === null) {
		throw new Error(`Assertion failed, expected value to be present. Got ${value}`);
	}
}

export function assertDefined<T>(value: T): asserts value is Exclude<T, undefined> {
	if (value === undefined) {
		throw new Error('Assertion failed, expected value to be present. Got undefined');
	}
}
